import { useCallback, useMemo, useState } from 'react';
import { debounce } from 'lodash';
import { mapSelectReturnComponent } from './useTimeWindowReferenceData';
import Axios, { CancelTokenSource } from 'axios';
import { UseQueryResult } from 'react-query';

const DEBOUNCE_VALUE = 500;

export const useSearchQuery = (
  searchHandler: (
    input: string,
    cancelTokenSource: CancelTokenSource
  ) => UseQueryResult<any, unknown>,
  input: string = ''
) => {
  const [debouncedValue, setDebouncedValue] = useState(input);
  const cancelTokenSource = useMemo(() => {
    return Axios.CancelToken.source();
  }, [debouncedValue]);

  /* import 'refetch' if manual search run is desired. should be used together with lookup.GetReturnComponentsSearch() options like: { enabled: false, refetchOnWindowFocus: false } */
  const { data: { data } = { data: [] }, isLoading } = searchHandler(
    debouncedValue,
    cancelTokenSource
  );

  const resetSearch = () => {
    setDebouncedValue('');
    cancelTokenSource.cancel('Search query is canceled');
  };

  const debounceInput = useCallback(debounce((input?: string) => {
    setDebouncedValue(input || '');
  }, DEBOUNCE_VALUE), []);

  return {
    data: data.map(mapSelectReturnComponent),
    isLoading,
    debounceInput,
    resetSearch,
  };
};
